import React from 'react';
import { Grid } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button/index';
import {
    EXPORT_APPLICATION_SEARCH,
    DOWNLOAD_APPLICATION,
    EXPORT_APPLICATION_SEARCH_NTEC,
    GET_POST_APPROVAL_ZIP,
    EXPORT_FOR_CCO,
    SHOW_SELECT_TEMPLATE_BOX,
    SET_SELECT_TEMPLATE_BOX,
} from 'store/key';
import { useDispatch } from 'react-redux';
import { searchDocTypeEnum } from 'hooks/search/searchData';
import { setGlobalLoading } from 'store/global/reducer';
import { useSelector } from 'react-redux';
import { CCO, SECRETARY, HO_ADMIN } from 'utility/lookup';

export default function Search({ loadList, selectedRows = [], resetData, searchData, isValid, resultRows }) {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const { isLoading, docType, conditionsRequests } = searchData;

    const handleReset = () => {
        resetData();
    };

    const handleExport = (e, flag) => {
        if (isValid()) {
            const data = {
                docType: docType,
                conditionsRequests: conditionsRequests,
                sort: 'updateDtm',
                isDesc: true,
            };

            setGlobalLoading(true);

            dispatch({
                type: flag === 'ntec' ? EXPORT_APPLICATION_SEARCH_NTEC : EXPORT_APPLICATION_SEARCH,
                payload: {
                    data: data,
                    callback: () => setGlobalLoading(false),
                },
            });
        }
    };

    const handleDownload = () => {
        if (isValid()) {
            setGlobalLoading(true);
            if (docType === searchDocTypeEnum.INIT_APPLICATION) {
                /** download initial application */
                const requestData = selectedRows.map((item) => {
                    let data = {
                        id: item.id,
                        docType,
                    };
                    return data;
                });

                dispatch({
                    type: DOWNLOAD_APPLICATION,
                    payload: {
                        data: requestData,
                        callback: () => setGlobalLoading(false),
                    },
                });
            } else {
                /** download post approval document */
                const type = selectedRows[0].docType;
                const reportId = selectedRows[0].id;
                dispatch({
                    type: GET_POST_APPROVAL_ZIP,
                    payload: {
                        docType: type,
                        docId: reportId,
                        final: () => setGlobalLoading(false),
                    },
                });
            }
        }
    };
    const getDownloadText = () => {
        let text = '';
        if (docType) {
            if (docType === searchDocTypeEnum.INIT_APPLICATION) {
                text = 'Application';
            } else {
                text = 'Post Approval Document';
            }
        }
        return text;
    };

    const exportToJsonPermission = () => {
        if (user.role === SECRETARY && user.detail.secretarySubType === 'NTEC') {
            return true;
        }

        if (user.role === SECRETARY && user.detail.secretarySubType === 'HKWC') {
            return true;
        }

        if (user.role === CCO) {
            return true;
        }

        return false;
    };

    const handleCCOTemplateDownload = () => {
        dispatch({
            type: SET_SELECT_TEMPLATE_BOX,
            payload: {
                selectTemplateBox: {
                    isShow: true,
                    handleConfirm: (selectedTemplate) => {
                        if (isValid()) {
                            let temp = [...conditionsRequests];
                            const approvedObj = {
                                "fieldName": "statusId",
                                "fieldValue": 7,
                                "operatorType": "EQ"
                            };
                            const findStatus = temp.findIndex(item => item.fieldName === 'statusId')
                            if (findStatus !== -1) {
                                temp[findStatus] = approvedObj;
                            } else {
                                temp.push(approvedObj);
                            }
                            const data = {
                                conditionsRequests: temp,
                                docType: "INIT_APPLICATION",
                                sort: "updateDtm",
                                isDesc: true,
                            };
                            setGlobalLoading(true);
                            dispatch({
                                type: EXPORT_FOR_CCO,
                                payload: {
                                    data: data,
                                    callback: () => setGlobalLoading(false),
                                    type: selectedTemplate,
                                },
                            });
                        }
                    }
                }
            }
        });

    }

    return (
        <Grid container wrap="nowrap">
            <Grid>
                <CustomButton onClick={() => loadList(null, 1)}>Search</CustomButton>
            </Grid>
            <Grid style={{ margin: '0 16px' }}>
                <CustomButton onClick={handleReset}>Reset</CustomButton>
            </Grid>

            <Grid>
                <CustomButton onClick={handleExport}>
                    Export To XLS
                </CustomButton>
            </Grid>
            <Grid style={{ margin: '0 16px' }}>
                <CustomButton disabled={isLoading || !selectedRows.length} onClick={handleDownload}>
                    Download {getDownloadText()}
                </CustomButton>
            </Grid>

            {/* only ntec secretary can view this button */}
            {exportToJsonPermission() && (
                <Grid>
                    <CustomButton
                        disabled={isLoading || !resultRows.length}
                        onClick={(e) => {
                            handleExport(e, 'ntec');
                        }}
                    >
                        Export For JSON
                    </CustomButton>
                </Grid>
            )}
            {
                [CCO, SECRETARY, HO_ADMIN].includes(user.role) && <Grid style={{ margin: '0 16px' }}>
                    <CustomButton disabled={isLoading || !resultRows.length || searchData?.docType !== "INIT_APPLICATION"} onClick={handleCCOTemplateDownload}>
                        Export CCO Template
                    </CustomButton>
                </Grid>
            }
        </Grid>
    );
}
